import { Record } from 'immutable';
import { Values } from './types';

export const createInitialValues = Record<Values>({ email: '' });
